import React, {FC,   useState} from 'react';
import {useTranslation} from "react-i18next";
import {Input, Select} from "../../../components/FormControls";
import {ReactSVG} from "react-svg";
import filter_svg from '../assets/icons/filter.svg';
import {
  ECountry,  IGetPerformerStatsRequest,
  IGetYoutuberStatsRequest,
} from "../../../modules/rest";
import FilterSelectedItem from "./FilterSelectedItem";
import FilterSelectedList from "./FilterSelectedList";
import {Countries} from "../../../modules/directory";
import geos from "../../../translates/geos.json";
import ReportsFiltersHead from "./ReportsFiltersHead";
import ReportsFiltersCount from "./ReportsFiltersCount";
import moment from "moment";
import countries from "../../../translates/countries.en.json";


interface Props {
  request: IGetPerformerStatsRequest;
  updateState: (request: Partial<IGetPerformerStatsRequest>) => void;
  visible?: boolean;
}

const ReportsFilters: FC<Props> = ({request, updateState, visible}) => {
  const {t} = useTranslation();
  const [visibleType, setVisibleType] = useState<IGetYoutuberStatsRequest['group']>();

  const handleChangeGeo = (geo: ECountry, remove?: boolean) => {
    const countries = request.country as ECountry[];
    if (!countries.includes(geo)) return updateState({country: [...countries, geo]});
    if (remove) updateState({country: countries.filter(g => g !== geo)})
  };

  const handleChangeDate = (period: 'periodBegin'|'periodEnd') => (e: any) => {
    const date = e.target.value
    if (moment(date).isValid()) {
      updateState({[period]: date});
    }
  };

  const handleClearAll = () => {
    updateState({country: [], periodEnd: '', periodBegin: ''});
  };

  const handleClick = (type: IGetYoutuberStatsRequest['group']) => () => {
    setVisibleType(prevState => {
      if (prevState !== type) return type;
      return;
    })
  }

  return (
    <div className={`report-filters${visible ? ' visible' : ''}`}>
      <div className="report-filters-block">
        <div className='report-filters-block-head'>
          <ReactSVG src={filter_svg} className='react-icon'/>
          <span className='ps-2'>{t('FILTER')}</span>
          <ReportsFiltersCount
            accent
            len={(request.country?.length || 0) + ((request?.periodBegin || request?.periodEnd) ? 1 : 0)}
            onClick={handleClearAll}
          />
        </div>

        <div className="report-filters-block-body">

          <div className={`report-filters-block-body-item${visibleType === "country" ? ' visible' : ''}`}>
            <ReportsFiltersHead
              title='COUNTRIES'
              len={request.country?.length}
              onClear={() => updateState({country: []})}
              onClick={handleClick("country")}
            />
            <div className="report-filters-block-body-content">
              <FilterSelectedList>
                {(request.country as ECountry[])?.map(geo => (
                  <FilterSelectedItem
                    key={geo}
                    //@ts-ignore
                    name={geos[geo.toUpperCase()]?.name || geo}
                    onClick={() => handleChangeGeo(geo, true)}
                  />
                ))}
              </FilterSelectedList>
              <Select
                onChange={(e) => handleChangeGeo(e.target.value)}
              >
                <option value=''>-- {t('SELECT_COUNTRY')} --</option>
                {Object.entries(Countries).map(([k, v]) => (
                  <option value={k} key={k}>
                    {/*@ts-ignore*/}
                    {countries[k]}
                  </option>
                ))}
              </Select>
            </div>
          </div>
          <div className={`report-filters-block-body-item${visibleType === "period" ? ' visible' : ''}`}>
            <ReportsFiltersHead
              title='PERIOD'
              len={request.periodBegin || request.periodEnd ? 1 : 0}
              onClear={() => updateState({periodBegin: '', periodEnd: ''})}
              onClick={handleClick("period")}
            />
            <div className="report-filters-block-body-content">
              <FilterSelectedList>
                {request.periodBegin
                  ?
                  <FilterSelectedItem
                    name={`${t('FROM')} ${request.periodBegin}`}
                    onClick={() => updateState({periodBegin: ''})}
                  />
                  :
                  null
                }
                {request.periodEnd
                  ?
                  <FilterSelectedItem
                    name={`${t('TILL')} ${request.periodEnd}`}
                    onClick={() => updateState({periodEnd: ''})}
                  />
                  :
                  null
                }
              </FilterSelectedList>
              <div className='input-group'>
                <Input
                  max={(!request.periodBegin ? (request?.periodEnd) : '') || ''}
                  onKeyDown={(e) => e.preventDefault()}
                  required
                  type={'date'}
                  className='sm w-50'
                  placeholder={t('FROM') || ''}
                  value={request.periodBegin || ''}
                  onChange={handleChangeDate('periodBegin')}
                />
                <Input
                  min={(!request.periodEnd ? (request?.periodBegin) : '') || ''}
                  onKeyDown={(e) => e.preventDefault()}
                  type='date'
                  className={'sm w-50'}
                  placeholder={t('TILL') || ''}
                  value={request.periodEnd || ''}
                  onChange={handleChangeDate('periodEnd')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportsFilters;